import * as React from 'react';
import { FC, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ToolBar from './ToolBar';
// import WeeklyPacksPerNature from './WeeklyPacksPerNature';
import MonthlyPacksPerNature from './MonthlyPacksPerNature';
// import WeeklyQuantitiesPerNature from './WeeklyQuantitiesPerNature';
import MonthlyQuantitiesPerNature from './MonthlyQuantitiesPerNature';
import { Customer, Order, Review } from '../../types';
interface Nature {
    id: string;
    name: string;
}

interface CustomerData {
    [key: string]: Customer;
}

interface State {
    nbNewOrders?: number;
    nbPendingReviews?: number;
    pendingOrders?: Order[];
    pendingOrdersCustomers?: CustomerData;
    pendingReviews?: Review[];
    pendingReviewsCustomers?: CustomerData;
    recentOrders?: Order[];
    revenue?: number;
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '0em',
        // backgroundColor: 'red',
    },
    flex: { display: 'flex' },
    flexColumn: {
        display: 'flex',
        marginBottom: '0em',
        // backgroundColor: 'red',
    },
    leftCol: { flex: 1, marginRight: '0em' },
    rightCol: { flex: 1, marginLeft: '0em' },
    kpiContainer: { padding: '1em' },
    // singleCol: { marginTop: '0.5em', marginBottom: '0.5em' },
}));

// const Spacer = () => <span style={{ width: '1em' }} />;
// const VerticalSpacer = () => <span style={{ height: '1em' }} />;

const NatureDashboard: FC<any> = ({ lastyear = false }) => {
    const [nature, setNature] = useState('all');

    const classes = useStyles();

    return (
        <div className={classes.container}>
            {/* <div className={classes.flexColumn}>
                <div className={classes.leftCol}>
                    <div className={classes.kpiContainer}>
                        <ToolBar setNature={setNature} />
                    </div>
                </div>
                <div className={classes.rightCol}></div>
            </div> */}
            <div className={classes.flexColumn}>
                {/* <div className={classes.leftCol}>
                    <div className={classes.kpiContainer}>
                        <WeeklyPacksPerNature nature={nature} height={200} />
                    </div>
                    <div className={classes.kpiContainer}>
                        <WeeklyQuantitiesPerNature
                            nature={nature}
                            height={200}
                        />
                    </div>
                </div> */}
                <div className={classes.rightCol}>
                    {/* <div className={classes.kpiContainer}>
                        <MonthlyPacksPerNature nature={nature} height={250} />
                    </div> */}
                    <div className={classes.kpiContainer}>
                        <MonthlyQuantitiesPerNature
                            lastyear={lastyear}
                            nature={nature}
                            height={250}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NatureDashboard;
